import React, { useState, useCallback, useEffect } from 'react';
import { nameIconMap } from '../../mappings/title_icon_hexcode_mapping';
import AssetViewer from '../book-viewer/AssetViewer';
import DefaultIcon from '../../assets/images/default-icon.svg';
import { trackEvent } from '../../segment';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { setAssetViewerOpen } from '../../features/assetViewer/assetViewerSlice';

interface ResourceCardProps {
    res_type: string;
    res_title: string;
    media_type: string;
    res_id: string;
    url: string;
    book_uri: string;
    img_src: string;
    ops_path: string;
    bookId: string;
    resExtenstion: string;
    bookPageNum: number;
    visualPageNum: number;
}

interface Asset {
    mediaType: string;
    resTitle: string;
    resId: string;
    resPath: string;
}

const ResourceCard: React.FC<ResourceCardProps> = ({
    res_type,
    media_type,
    res_title,
    res_id,
    url,
    book_uri,
    img_src,
    ops_path,
    bookId,
    resExtenstion,
    visualPageNum,
    bookPageNum,
}) => {
    const [iconSrc, setIconSrc] = useState<string>(
        nameIconMap[res_type.trim()]?.icon_path ||
            `${book_uri}/${ops_path}/${img_src}` ||
            DefaultIcon
    );
    const bgHexCode =
        nameIconMap[res_type.trim()]?.background_hexcode || '#DAE8FB';
    const isAssetViewerOpen = useSelector(
        (state: RootState) => state.AssetViewer.isOpen
    );
    const [resObj, setResObj] = useState<Asset | null>(null);
    const dispatch = useDispatch();
    const handleError = () => {
        setIconSrc(DefaultIcon);
    };

    const handleClick = () => {
        //old event
        trackEvent('asset_resource_viewed', {
            res_type: res_type,
            res_id: res_id,
            res_title: res_title,
        });

        setResObj({
            mediaType: media_type,
            resTitle: res_title,
            resId: res_id,
            resPath: url,
        });
        dispatch(setAssetViewerOpen(true));
        
    };

    const closePopup = useCallback(() => {
        dispatch(setAssetViewerOpen(false));
        setResObj(null);
    }, []);

    const isPremiumButton = ['ARI', 'IRA', 'PIE'].includes(res_type);
    useEffect(() => {
        if (isAssetViewerOpen && resObj && resObj.mediaType == 'buildr') {
            //old event
            trackEvent('redirection_to_lab_from_epub', {
                source: 'assets tab',
            });
        }
    }, [isAssetViewerOpen, resObj]);
    return (
        <div>
            <div
                className={`rounded-2xl flex w-auto px-3 py-1 m-1 text-black items-center hover cursor-pointer`}
                style={{ background: bgHexCode }}
                onClick={handleClick}
            >
                <img
                    className="mr-1 h-12"
                    src={iconSrc}
                    alt="icon"
                    onError={handleError}
                />
                <div className="flex flex-col">
                    <h1
                        className={`font-semibold text-xs ${
                            res_type ? '' : 'mt-2'
                        } ${isPremiumButton ? 'text-white' : 'text-black'}`}
                    >
                        {res_type}
                    </h1>
                    {res_title && (
                        <p
                            className={`font-normal text-xs ${
                                isPremiumButton ? 'text-white' : 'text-black'
                            }`}
                        >
                            {res_title}
                        </p>
                    )}
                </div>
            </div>
            {isAssetViewerOpen && resObj && (
                <AssetViewer
                    isOpen={isAssetViewerOpen}
                    onClose={closePopup}
                    type={resObj.mediaType}
                    resId={resObj.resId}
                    resPath={resObj?.resPath}
                    bookUri={book_uri}
                    bookId={bookId}
                    source="Assets Resource Card"
                    resTitle={res_title}
                    resExtenstion={resExtenstion}
                    visualPageNum={visualPageNum}
                    bookPageNum={bookPageNum}
                />
            )}
        </div>
    );
};

export default React.memo(ResourceCard);
